import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { lazy } from 'utils/generic/lazy';
import { PartnerConfig } from 'interfaces/partner-config';
import { getPartnerConfigs } from 'store/selectors/socket';
import { getIsLoggedIn } from 'store/selectors/user-data';

const { LoyaltyDataFetcher } = lazy(
  () =>
    import(/* webpackChunkName: "LoyaltyDataFetcher" */ './LoyaltyDataFetcher')
);

export const LoyaltyDataFetcherWrapper = () => {
  const partnerConfigs = useSelector(getPartnerConfigs) as PartnerConfig;
  const isLoggedIn = useSelector(getIsLoggedIn);

  const isLoyaltyV2 =
    partnerConfigs?.is_using_loyalty_program && !!partnerConfigs?.is_loyalty_v2;

  const shouldFetch = isLoggedIn && isLoyaltyV2;

  return shouldFetch ? (
    <Suspense>
      <LoyaltyDataFetcher />
    </Suspense>
  ) : null;
};
